export default __webpack_public_path__ + "2eeb4078a441a00e2312b8b30c380b37.json";